<template>
  <div id="menu-wrap">
    <div id="view-side-menu-wrap">
      <input
        type="checkbox"
        name="viewSideMenu"
        v-model="viewSideMenu"
        id="view-side-menu"
        style="z-index: 3"
      />
      <span id="post-view-side-menu"></span>
    </div>
    <div id="dice-button-wrap">
      <router-link
        id="dice-button"
        :to="this.$route.path === '/dice' ? this.previousRoute : '/dice'"
      >{{ this.$route.path === '/dice' ? 'BACK' : 'DICE'}}</router-link>
    </div>
    <div class="menu-side" :style="viewSideMenu ? '' : 'z-index: -1'">
      <div class="side-routes" v-show="viewSideMenu">
        <div class="route" v-for="route in routerData" :key="route.path">
          <router-link
            :to="route.path"
            v-if="route.component.name !== 'Dice'"
          >{{ route.component.name + (route.path === $route.path ? '  *' : '')}}</router-link>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <div :class="viewSideMenu ? 'view-overlay' : ''"></div>
  </div>
</template>

<script>
import router from "../router.js";

export default {
  name: "Menu",
  data() {
    return {
      routerData: [],
      viewSideMenu: false,
      previousRoute: "",
    };
  },
  created() {
    this.routerData = router;
  },
  methods: {
    routeChange: function() {
      this.previousRoute = localStorage.getItem("previousRoute");
      this.viewSideMenu = false;
    }
  },
  watch: {
    $route: "routeChange"
  }
};
</script>

<style lang="css">
.menu-side {
  float: left;
  text-align: left;
  position: fixed;
  margin-left: 1em;
  margin-top: 1em;
  z-index: 3;
}

#view-side-menu-wrap {
  position: fixed;
  right: 15px;
  top: 15px;
  z-index: 99;
}

#view-side-menu {
  width: 1.5em;
  height: 1.5em;
  border: 1px solid #2c3e50;
  border-radius: 3px;
  background: #73c482 !important;
}

#dice-button-wrap {
  position: fixed;
  right: 15px;
  bottom: 15px;
}

#dice-button-wrap > #dice-button {
  display: flex;
  width: 4.2em;
  height: 4.2em;
  align-items: center;
  justify-content: center;
  background: #73c482;
  color: white;
  font-size: 24px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 100%;
  -webkit-transition: 0.05s;
  transition: 0.05s;
}

.view-overlay {
  position: fixed;
  background: linear-gradient(100deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.55));
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}

.route {
  padding: 0.5em 0;
}

.route > a {
  text-decoration: none;
  color: white;
  font-size: 2em;
  width: 100%;
}
</style>